import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const wedding = useContent();
  return (
    <footer className="bg-ink text-white pt-20 pb-10 grain relative border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 text-center">
        <p className="overline text-white/50">Nos casamos</p>
        <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl mt-6 tracking-tight">
          {wedding.bride} <span className="italic font-light">&amp;</span> {wedding.groom}
        </h2>
        <p className="font-display italic text-2xl text-white/70 mt-6">{wedding.dateLabel}</p>
        <p className="overline text-white/40 mt-10">{wedding.hashtag}</p>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-light text-white/40">
            © {new Date().getFullYear()} — Hecho con amor.
          </p>
          <Link
            to="/admin"
            className="overline text-white/40 hover:text-white transition-colors"
            data-testid="footer-admin-link"
          >
            Panel de Administración
          </Link>
        </div>
      </div>
    </footer>
  );
}
